import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GitUiDisplayOutletComponent } from './git-ui-display-outlet.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GitUiDisplayOutletComponent],
  exports: [GitUiDisplayOutletComponent],
})
export class GitUiDisplayModule {}
